import { Permission } from '@shared/infrastructure/auth/permission.js';
import type { AppModule } from '@shared/presentation/router/composition.js';
import { VP_SECTION_NAV } from '../presentation/section-nav.js';

/**
 * `overview` feature: the module's hub.
 *
 * The only Virtual Profiler entry in the menu. The queue, the videos, the groups
 * and the configuration are reached from here and from the module nav on every
 * screen, not from the sidebar, which stays lit on all of them by route name.
 *
 * It renders inside the shell, hence `layoutRoutes`. With no `meta.public`, the
 * guard protects it — which is the default behavior — and `meta.permission` is
 * what hides it, and with it the whole module, from whoever cannot read.
 */
export const virtualProfilerOverviewModule: AppModule = {
  name: 'virtual-profiler-overview',
  routes: [],
  layoutRoutes: [
    {
      path: 'virtual-profiler',
      name: 'virtual-profiler',
      component: () => import('./presentation/VirtualProfilerView.vue'),
      meta: { permission: Permission.VIRTUAL_PROFILER_READ, sectionNav: VP_SECTION_NAV },
    },
  ],
};
